export class HuntGroupAccounts {
    constructor(id: number, ids: number[]) {
        this.id = id;
        this.accountIds = ids;
    }

    id: number;
    accountIds: number[];
}
